/** Which app store a visitor's device uses. Shared by the Worker and the web. */
export type Platform = "ios" | "android";

/**
 * The visitor's phone, or null on a computer (or anything else), which then gets both stores.
 * iPadOS asks for desktop sites and says "Macintosh"; only its touch screen gives it away.
 */
export function platformOf(userAgent: string, maxTouchPoints = 0): Platform | null {
  if (/Android/i.test(userAgent)) return "android";
  if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)) return "ios";
  return null;
}

export const playStoreUrl = (packageName: string): string =>
  `https://play.google.com/store/apps/details?id=${encodeURIComponent(packageName)}`;

/**
 * The app links for a button labelled `label`: one, for the visitor's own store, or on a computer
 * one for each, named for the phone it's for.
 */
export function storeLinks(
  urls: { appStoreUrl: string; playStoreUrl: string }, platform: Platform | null, label: string,
): { href: string; label: string }[] {
  if (platform === "ios") return [{ href: urls.appStoreUrl, label }];
  if (platform === "android") return [{ href: urls.playStoreUrl, label }];
  return [
    { href: urls.appStoreUrl, label: `${label} for iPhone` },
    { href: urls.playStoreUrl, label: `${label} for Android` },
  ];
}
